import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    steps_statuses: ['active', 'disabled'],
    blocks        : [
      {
        id     : 0,
        active : true,
        name   : 'Базовые знания',
        text   : 'Блок 1. Базовые знания',
        lessons: [
          {
            id      : 0,
            text    : 'Введение',
            active  : true,
            disabled: false,
            block   : 0,
            db_id   : '10',
          },
        ],
      },
      {
        id     : 1,
        active : false,
        name   : 'Специальные знания',
        text   : 'Блок 2. Специальные знания',
        lessons: [
          {
            id      : 0,
            text    : 'Функции товарных масел',
            active  : false,
            disabled: false,
            block   : 1,
            db_id   : '20',
          },
        ],
      },
    ],
  },
  getters: {
    lessons_total: ({blocks}) => {
      let result = 0;
      if (blocks) {
        var filteredBlocks = blocks.filter((block) => block && block.lessons);
        filteredBlocks.forEach((block) => {
          result += block.lessons.length;
        });
      }
      return result;
    },

    blocks: ({blocks = []}) => {
      return blocks.filter((block) => block && block.lessons);
    },

    current_block: (state, getters) => {
      var blocks = getters.blocks;
      if (blocks && blocks.length) {
        var result = blocks.find((block) => block.active === true);
        if (result) {
          return result.id;
        }
      }
      return 0;
    },

    current_lesson_obj: (state, getters) => {
      var blocks = getters.blocks;
      if (blocks && blocks.length) {
        // Сначала ищем активный блок и активный урок
        for (var i = 0; i < blocks.length; i++) {
          var block = blocks[i];
          if (block && block.active === true && block.lessons) {
            for (var j = 0; j < block.lessons.length; j++) {
              var lesson = block.lessons[j];
              if (lesson && lesson.active === true) {
                return lesson;
              }
            }
          }
        }

        // Если не нашли, ищем любой активный урок в любом блоке
        for (var k = 0; k < blocks.length; k++) {
          var currentBlock = blocks[k];
          if (currentBlock && currentBlock.lessons) {
            for (var l = 0; l < currentBlock.lessons.length; l++) {
              var currentLesson = currentBlock.lessons[l];
              if (currentLesson && currentLesson.active === true) {
                return currentLesson;
              }
            }
          }
        }
      }

      // Если ничего не нашли, возвращаем первый урок первого блока
      var allBlocks = getters.blocks;
      if (allBlocks && allBlocks.length > 0 && allBlocks[0] && allBlocks[0].lessons && allBlocks[0].lessons.length > 0) {
        return allBlocks[0].lessons[0];
      }

      return null;
    },

    last_lesson_in_block: (state, getters) => (blockId, lessonId) => {
      var blocks = getters.blocks;
      if (!blocks || !blocks.length) return false;

      var targetBlock = blocks.find((x) => x && x.id === blockId);
      if (targetBlock && targetBlock.lessons && targetBlock.lessons.length) {
        var targetLesson = targetBlock.lessons.find((x) => x && x.id === lessonId);
        var lastLesson = targetBlock.lessons[targetBlock.lessons.length - 1];
        return targetLesson && lastLesson && lastLesson.id === targetLesson.id;
      }
      return false;
    },

    current_lesson_path: (state, getters, rootState, rootGetters) => {
      var blocks = getters.blocks;
      var blockId = 0;
      var lessonId = 0;

      if (blocks && blocks.length) {
        // Ищем активный урок
        for (var i = 0; i < blocks.length; i++) {
          var block = blocks[i];
          if (block && block.lessons) {
            for (var j = 0; j < block.lessons.length; j++) {
              var lesson = block.lessons[j];
              if (lesson && lesson.active === true) {
                return [block.id, lesson.id];
              }
            }
          }
        }

        // Если не нашли активный урок, ищем активный блок
        for (var k = 0; k < blocks.length; k++) {
          var activeBlock = blocks[k];
          if (activeBlock && activeBlock.active === true && activeBlock.lessons && activeBlock.lessons.length > 0) {
            return [activeBlock.id, activeBlock.lessons[0].id];
          }
        }

        // Если ничего не нашли, берем первый урок первого блока
        if (blocks[0] && blocks[0].lessons && blocks[0].lessons.length > 0) {
          return [blocks[0].id, blocks[0].lessons[0].id];
        }
      }

      return [0, 0];
    },

    last_lesson_path: (state, getters) => {
      var blocks = getters.blocks;
      if (blocks && blocks.length) {
        var lastBlock = blocks[blocks.length - 1];
        if (lastBlock && lastBlock.lessons && lastBlock.lessons.length) {
          var lastBlockId = lastBlock.id;
          var lastLessonId = lastBlock.lessons[lastBlock.lessons.length - 1].id;
          return [lastBlockId, lastLessonId];
        }
      }
      return [0, 0];
    },

    current_lesson_is_last_lesson: (state, getters) => {
      var currentPath = getters.current_lesson_path;
      var lastPath = getters.last_lesson_path;
      var currentBlock = currentPath[0];
      var currentLesson = currentPath[1];
      var lastBlock = lastPath[0];
      var lastLesson = lastPath[1];
      return (currentBlock === lastBlock && currentLesson === lastLesson);
    },

    check_lesson_not_passed: (state, getters) => {
      var currentPath = getters.current_lesson_path;
      var currentBlock = currentPath[0];
      var currentLesson = currentPath[1];
      var blocks = getters.blocks;

      if (!blocks || !blocks.length) return true;

      var isLastLesson = getters.current_lesson_is_last_lesson;

      if (isLastLesson) {
        return true;
      }

      if (currentBlock >= blocks.length) return true;

      var targetBlock = blocks[currentBlock];
      if (!targetBlock || !targetBlock.lessons) return true;

      var isLastInBlock = getters.last_lesson_in_block(currentBlock, currentLesson);

      var nextLesson = null;
      if (!isLastInBlock) {
        if (currentLesson + 1 < targetBlock.lessons.length) {
          nextLesson = targetBlock.lessons[currentLesson + 1];
        }
      } else {
        if (currentBlock + 1 < blocks.length) {
          var nextBlock = blocks[currentBlock + 1];
          if (nextBlock && nextBlock.lessons && nextBlock.lessons.length) {
            nextLesson = nextBlock.lessons[0];
          }
        }
      }

      return nextLesson ? nextLesson.disabled : true;
    },
  },

  mutations: {
    NEXT_LESSON(state, obj) {
      var block = obj.block;
      var lesson = obj.lesson;
      if (block === undefined || lesson === undefined) return;

      var filteredBlocks = state.blocks.filter((block) => block && block.lessons);

      if (filteredBlocks[block] &&
          filteredBlocks[block].lessons &&
          filteredBlocks[block].lessons[lesson]) {
        filteredBlocks[block].lessons[lesson].disabled = false;
      }
      state.blocks = filteredBlocks;
    },

    RESET_LESSONS(state) {
      var filteredBlocks = state.blocks.filter((block) => block && block.lessons);
      for (var i = 0; i < filteredBlocks.length; i++) {
        var itemBlock = filteredBlocks[i];
        itemBlock.active = false;
        if (itemBlock.lessons) {
          for (var j = 0; j < itemBlock.lessons.length; j++) {
            itemBlock.lessons[j].active = false;
          }
        }
      }
      state.blocks = filteredBlocks;
    },

    TO_LESSON(state, obj) {
      console.debug("TO_LESSON state, obj", state, obj);
      var block = obj.block;
      var lesson = obj.lesson;

      if (block === undefined || lesson === undefined) {
        console.error('TO_LESSON: block or lesson is undefined', obj);
        return;
      }

      var filteredBlocks = state.blocks.filter((block) => block && block.lessons);

      var blockFound = false;
      for (var i = 0; i < filteredBlocks.length; i++) {
        var itemBlock = filteredBlocks[i];
        if (itemBlock.id === block) {
          blockFound = true;
          itemBlock.active = true;
          if (itemBlock.lessons) {
            for (var j = 0; j < itemBlock.lessons.length; j++) {
              var itemLesson = itemBlock.lessons[j];
              itemLesson.active = (itemLesson.id === lesson);
            }
          }
        } else {
          itemBlock.active = false;
          if (itemBlock.lessons) {
            for (var k = 0; k < itemBlock.lessons.length; k++) {
              itemBlock.lessons[k].active = false;
            }
          }
        }
      }

      // Если блок не найден, устанавливаем первый урок первого блока
      if (!blockFound && filteredBlocks.length > 0) {
        filteredBlocks[0].active = true;
        if (filteredBlocks[0].lessons && filteredBlocks[0].lessons.length > 0) {
          filteredBlocks[0].lessons[0].active = true;
        }
      }

      state.blocks = filteredBlocks;
    },

    SET_COURSE_STEPS(state, steps) {
      if (steps) {
        state.blocks = steps.blocks || state.blocks;
        state.steps_statuses = steps.steps_statuses || state.steps_statuses;
      }
    },

    SET_ACTIVE_LESSON_FROM_NEXT(state, nextLesson) {
      if (!nextLesson || !state.blocks) return;

      var block_id = nextLesson.block_id;
      var lesson_id = nextLesson.lesson_id;
      if (block_id === undefined || lesson_id === undefined) return;

      var filteredBlocks = state.blocks.filter((block) => block && block.lessons);

      for (var i = 0; i < filteredBlocks.length; i++) {
        var itemBlock = filteredBlocks[i];
        if (itemBlock.id === block_id) {
          itemBlock.active = true;
          if (itemBlock.lessons) {
            for (var j = 0; j < itemBlock.lessons.length; j++) {
              var itemLesson = itemBlock.lessons[j];
              itemLesson.active = (itemLesson.id === lesson_id);
            }
          }
        } else {
          itemBlock.active = false;
          if (itemBlock.lessons) {
            for (var k = 0; k < itemBlock.lessons.length; k++) {
              itemBlock.lessons[k].active = false;
            }
          }
        }
      }

      state.blocks = filteredBlocks;
    },
  },

  actions: {
    async next_step({dispatch, commit, getters, rootGetters}) {
      var course_completed = rootGetters['course_info/course_completed'];
      var check_lesson_not_passed = getters.check_lesson_not_passed;
      var current_lesson_obj = getters.current_lesson_obj;
      var lessons_total = getters.lessons_total;
      var course_id = rootGetters['course_info/content/course_id'];
      var lessons_passed = rootGetters['course_info/lessons_passed'];
      var points_required_test = rootGetters['course_info/points_required_test'];

      if (!current_lesson_obj) {
        console.error('next_step: current_lesson_obj is undefined');
        var nextLesson = rootGetters['course_info/next_lesson'];
        if (nextLesson) {
          commit('SET_ACTIVE_LESSON_FROM_NEXT', nextLesson);
          // После установки пробуем получить объект урока снова
          current_lesson_obj = getters.current_lesson_obj;
          if (!current_lesson_obj) {
            return;
          }
        } else {
          return;
        }
      }

      window.scrollTo(0, 0);

      if (lessons_passed == lessons_total || course_completed) {
        commit('testing/CLEAR_TIMER', {}, {root: true});
        if (points_required_test > 0) {
          commit('course_info/modals/OPEN_MODAL', 'test', {root: true});
        }
      } else if (lessons_passed == lessons_total - 1) {
        var lesson = {
          lesson: current_lesson_obj.db_id,
        };
        commit('course_info/POINTS_ADDED', {}, {root: true});
        if (points_required_test > 0) {
          commit('course_info/modals/OPEN_MODAL', 'test', {root: true});
        }
        commit('course_info/COMPLETE_COURSE', {}, {root: true});
        try {
          await api.course.save_course_progress(course_id, lesson);
        } catch (err) {
          console.error(err);
        }
      } else {
        var lessonData = {
          lesson: current_lesson_obj.db_id,
        };
        await dispatch('next_step_course');

        if (check_lesson_not_passed) {
          if (lessons_passed < lessons_total) {
            if (lessons_passed == lessons_total - 1) {
              commit('course_info/POINTS_ADDED', {}, {root: true});
            } else {
              commit('course_info/POINTS_ADDED', {}, {root: true});
              commit('course_info/NEXT_LESSON', {}, {root: true});
            }
            try {
              await api.course.save_course_progress(course_id, lessonData);
            } catch (err) {
              console.error(err);
            }
          }
        } else {
          commit('course_info/NEXT_LESSON', {}, {root: true});
        }
      }
    },

    next_step_course({commit, getters, rootGetters}) {
      var current_block = getters.current_block;
      var current_lesson_obj = getters.current_lesson_obj;
      var last_lesson_in_block = getters.last_lesson_in_block;
      var current_lesson_is_last_lesson = getters.current_lesson_is_last_lesson;
      var lessons_total = getters.lessons_total;
      var lessons_passed = rootGetters['course_info/lessons_passed'];

      if (!current_lesson_obj) {
        console.error('next_step_course: current_lesson_obj is undefined');
        return;
      }

      var id = current_lesson_obj.id;

      if (!last_lesson_in_block(current_block, id)) {
        var nextLessonId = id + 1;
        commit('TO_LESSON', {block: current_block, lesson: nextLessonId});
        if (lessons_passed <= lessons_total) {
          commit('NEXT_LESSON', {block: current_block, lesson: nextLessonId});
        }
      } else if (!current_lesson_is_last_lesson) {
        var nextBlock = current_block + 1;
        commit('TO_LESSON', {block: nextBlock, lesson: 0});
        if (lessons_passed <= lessons_total) {
          commit('NEXT_LESSON', {block: nextBlock, lesson: 0});
        }
      }
    },

    initializeActiveLesson({commit, rootGetters}) {
      var nextLesson = rootGetters['course_info/next_lesson'];
      if (nextLesson) {
        commit('SET_ACTIVE_LESSON_FROM_NEXT', nextLesson);
      }
    },
  },
};